// Pure helpers for the per-factura correction dialog (ShowReplenishment).
// Rows hold the operator's RAW input string while editing, so a cleared field
// doesn't collapse to 0 mid-edit — a 0 that reaches the backend zeroes that
// factura's received quantity. Blank/invalid input means "unchanged": fall
// back to the seeded bucket quantity (maxQuantity is seeded from it).

export const clampInvoiceCorrectionQuantity = (row) => {
    const parsed = parseInt(row.quantity, 10)
    if (Number.isNaN(parsed)) return row.maxQuantity
    // Corrections are decrease-only server-side, so never suggest more.
    return Math.min(row.maxQuantity, Math.max(0, parsed))
}

export const invoiceCorrectionsTotal = (rows) =>
    rows.reduce((sum, row) => sum + clampInvoiceCorrectionQuantity(row), 0)

// What correct-reception actually sends. On the per-invoice path the corrected
// SUM goes out as new_reception_quantity: the backend ignores it there (it
// reconciles per bucket) but requires the param, and the stale seeded total
// would contradict both invoice_corrections and the on-screen total.
export const buildCorrectionPayload = (invoiceCorrections, legacyQuantity) => {
    if (!invoiceCorrections.length) return { newQuantity: legacyQuantity, corrections: null }
    return {
        newQuantity: invoiceCorrectionsTotal(invoiceCorrections),
        corrections: invoiceCorrections.map((row) => ({ ...row, quantity: clampInvoiceCorrectionQuantity(row) })),
    }
}
